module.exports = __webpack_public_path__ + "static/img/kuma.76e8027.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/sponser/kuma.jpg
// module id = mRVm
// module chunks = 0